import type { Feature } from '@luna/gatekeeper';

export const installmentsActivation: Feature = {
    enabled: true,
    _description:
        'Enables active installments plan creation and display of create new plan button on the installments page and in the stripe header',
};
